export const ADDRESS = "13221 N 34th St. Phoenix, AZ 85032";
export const EMAIL = "info@archangelphx.org";
export const NUMBER = "(623)335-2057";
export const IG = "https://www.instagram.com/archangelmichaelphx/";
export const YOUTUBE = "https://www.youtube.com/@archangelmichaelamericanco8605";
export const FB = "https://www.facebook.com/ArchangelMichaelPhoenix";
export const SoundCloud = "https://soundcloud.com/archangel-michael-coptic";